import type {ReduxState} from '@/redux'

export const proveAvailableAdFormats = (state: ReduxState) => state.proveAdFormat.available;
export const proveAdFormatIsPending = (state: ReduxState) => state.proveAdFormat.isPending;
export const proveAdFormatIsError = (state: ReduxState) => state.proveAdFormat.isError;
